import styled from 'styled-components';
import { Field as BaseField } from '../../index.view';
interface TipProps {
  center?: boolean;
}

const TipWrapper = styled.div<TipProps>`
  display: flex;
  justify-content: ${({ center }: TipProps) => (center ? 'center' : 'space-between')};
  line-height: 0px;
`;

const Field = styled(BaseField)<TipProps>`
  color: ${({ center, theme: { color } }) => (center ? color.gray_500 : color.black)};
  font-weight: 400;
`;

const RemoveTip = styled.button`
  display: block;
  margin: 2px 0 0 auto;
  padding: 2px 0;
  background: transparent;
  border: none;
  font-size: 11px;
  font-weight: 500;
  color: #94a3b8;
  cursor: pointer;
  transition: color 0.15s ease;
  text-align: right;

  &:hover {
    color: #ef4444;
  }
`;

export { TipWrapper, Field, RemoveTip };
